var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLiftinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 54,
  height: 47,
  x: 5,
  y: 16,
  rx: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 26,
  r: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.705 32h2.59a1 1 0 0 1 .942.664L47 46H33l4.763-13.336a1 1 0 0 1 .942-.664z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 26,
  r: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.92 32h6.16a1 1 0 0 1 .996.917L30 44H20l.924-11.083A1 1 0 0 1 21.92 32zM23 56h4a1 1 0 0 0 1-1V44h-6v11a1 1 0 0 0 1 1zm2-54v10m-5-6 5-5 5 5m10 5V1m-5 6 5 5 5-5m-6.095 49h2.19a1 1 0 0 0 .995-.9L43 46h-6l.91 9.1a1 1 0 0 0 .995.9z"
}))));
export default SvgLiftinline;